import React, { Component } from 'react';
import _ from 'lodash';

import {
  StyledFilter,
  StyledButtonUp,
  StyledButtonDown,
  StyledFilterText,
  StyledWrapperFlex
} from './style';

import Loading from '../../../core/Loading';
import Icon from '../../../core/Icon';
import { Arrow } from '../../../../../assets/images/index';

import { navigateToFile } from '../../../../utils/navigate';
import Documents from '../../../views/Documents';
import { getTeamDriveFiles } from '../../../../utils/officeIntegration';

const formatOneDriveExtension = item => {
  if (!item.file) {
    return 'FOLDER';
  }

  switch (item.file.mimeType) {
    case 'application/vnd.openxmlformats-officedocument.wordprocessingml.document':
      return 'DOC';
    case 'application/pdf':
      return 'PDF';
    case 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet':
      return 'XLS';
    case 'image/png':
    case 'image/jpeg':
    case 'image/gif':
    case 'image/svg':
      return 'JPG';
    case 'application/vnd.openxmlformats-officedocument.presentationml.presentation':
      return 'PPT';
    case 'FOLDER':
      return 'FOLDER';
    default:
      return undefined;
  }
};

const formatFoldersData = folders =>
  folders.map(item => ({
    ...item,
    title: item.name,
    fileExtension: formatOneDriveExtension(item)
  }));

const ORDER = {
  ASC: 'asc',
  DESC: 'desc'
};

export default class OneDriveDocs extends Component {
  state = {
    breadcrumbData: [],
    currentFolder: null,
    currentFolderDocs: [],
    order: ORDER.ASC,
    loading: true
  };

  componentDidMount() {
    this.setState(() => ({
      currentFolder: 'root',
      breadcrumbData: [{ txt: 'Documentación OneDrive', id: 'root' }]
    }));
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.currentFolder !== this.state.currentFolder) {
      this.updateDocs();
    }
  }

  updateDocs = () => {
    const { teamId } = this.props;
    const { currentFolder } = this.state;
    this.setState(() => ({ loading: true, currentFolderDocs: [] }));

    getTeamDriveFiles(teamId, currentFolder).then(response => {
      const foldersUpdated = formatFoldersData(response.value);
      this.setState({
        loading: false,
        currentFolderDocs: [...foldersUpdated]
      });
    });
  };

  onBreadcrumbClick = selectedItem => {
    const { breadcrumbData } = this.state;
    const breadcrumbItemIndex = breadcrumbData.findIndex(
      item => item === selectedItem
    );

    this.setState({
      currentFolder: selectedItem.id,
      breadcrumbData: breadcrumbData.slice(0, breadcrumbItemIndex + 1)
    });
  };

  onFileClick = item => {
    if (item.fileExtension === 'FOLDER') {
      const { breadcrumbData } = this.state;
      this.setState({
        loading: true,
        currentFolder: item.id,
        breadcrumbData: [...breadcrumbData, { txt: item.name, id: item.id }]
      });
    } else {
      navigateToFile(item.webUrl);
    }
  };

  render() {
    const { currentFolderDocs, breadcrumbData, loading, order } = this.state;

    const files = _.orderBy(
      currentFolderDocs,
      file => (file.title || file.folderName).toLowerCase(),
      order
    );

    if (loading) {
      return (
        <StyledWrapperFlex>
          <Loading size="xl" />
        </StyledWrapperFlex>
      );
    }

    return (
      <StyledWrapperFlex>
        <StyledFilter>
          <StyledFilterText>Ordenar alfabéticamente</StyledFilterText>
          <StyledButtonDown
            title="de la Z a la A"
            onClick={() => this.setState(() => ({ order: ORDER.DESC }))}
            active={order === ORDER.DESC}
          >
            <Icon svg={Arrow} width="14px" height="16px" />
          </StyledButtonDown>
          <StyledButtonUp
            title="de la A a la Z"
            onClick={() => this.setState(() => ({ order: ORDER.ASC }))}
            active={order === ORDER.ASC}
          >
            <Icon svg={Arrow} width="14px" height="16px" />
          </StyledButtonUp>
        </StyledFilter>

        <Documents
          files={files}
          breadcrumb={breadcrumbData}
          onBreadcrumbClick={this.onBreadcrumbClick}
          onFileClick={this.onFileClick}
        />
      </StyledWrapperFlex>
    );
  }
}
